/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgExternalAttachment = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M22 22h-2v-2.174c-.423.368-.869.69-1.318.965C17.458 21.538 16.1 22 15 22v-2c.615 0 1.613-.288 2.64-.915A7.635 7.635 0 0 0 19.027 18H17v-2h5zM8.778 10.192 5.95 13.02a3 3 0 0 0 4.242 4.242l2.829-2.828 1.414 1.414-2.828 2.828a5 5 0 0 1-7.071-7.07l2.828-2.83z" />
        <path d="m15.85 8.778-7.072 7.071-1.414-1.414 7.071-7.071z" />
        <path d="M11.607 4.536a5 5 0 1 1 7.07 7.071l-2.828 2.828-1.414-1.414 2.828-2.83a3 3 0 1 0-4.242-4.241l-2.83 2.828-1.413-1.414z" />
      </g>
    </g>
  </Icon>
);
export { SvgExternalAttachment as ExternalAttachment };
